import { Directive, ViewContainerRef } from '@angular/core';
import { CdkTreeNodeOutlet } from '@angular/cdk/tree';

@Directive({
  selector: '[mcraiTreeNodeOutlet]'
})
export class OutletDirective implements CdkTreeNodeOutlet {

  constructor(
    public viewContainer: ViewContainerRef
  ) { }

}